import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ImageClickable } from './ImageClickable';
export function Modules() {
  const modules = [{
    num: 1,
    title: 'La mujer que NO se elige',
    desc: 'Entendé por qué te estás abandonando',
    img: 'https://cdn.magicpatterns.com/uploads/rNPmZZmASTZjcv74BSADio/Modulo_1.png'
  }, {
    num: 2,
    title: 'No te mientas más',
    desc: 'Dejá de justificar lo que ya sabés',
    img: 'https://cdn.magicpatterns.com/uploads/exk8G1Qw2mzSvDa4FvbMLd/Modulo_2.png'
  }, {
    num: 3,
    title: 'El egoísmo sano',
    desc: 'Aprendé a ponerte como prioridad sin culpa',
    img: 'https://cdn.magicpatterns.com/uploads/jSceJy4EY4YAqSKTELR7Ty/Modulo_3.png'
  }, {
    num: 4,
    title: 'Cerrando ciclos',
    desc: 'Soltá sin recaer',
    img: 'https://cdn.magicpatterns.com/uploads/h9FYNJoRoh4GKE7Pobc6WH/Modulo_4.png'
  }, {
    num: 5,
    title: 'La mujer que se elige',
    desc: 'Reconstruí tu vida desde vos',
    img: 'https://cdn.magicpatterns.com/uploads/35BxELDBiE1cdUikBj9mgb/Modulo_5.png'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleScroll = useCallback(() => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const scrollLeft = container.scrollLeft;
    const itemWidth = container.scrollWidth / modules.length;
    const newIndex = Math.round(scrollLeft / itemWidth);
    setActiveIndex(Math.min(newIndex, modules.length - 1));
  }, [modules.length]);
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    container.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
  return <section className="py-8 md:py-10 px-3 md:px-4 bg-black" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <div className="text-center mb-8" data-id="element-146">
          <p className="text-gray-400 mb-2" data-id="element-147">
            Esto no va de dejar de pensar en él. Va de{' '}
            <strong className="text-gray-200" data-id="element-148">
              cambiar lo que te pasa internamente
            </strong>
            .
          </p>
          <p className="text-gray-300 mb-4" data-id="element-149">
            Porque si no cambiás eso vas a{' '}
            <strong className="text-white" data-id="element-150">volver a lo mismo</strong>, con él o
            con otra persona.
          </p>
          <p className="text-terracota font-bold text-lg mb-6" data-id="element-151">
            Este sistema trabaja en eso: en <strong data-id="element-152">cortar el patrón</strong>,
            no en taparlo.
          </p>

          <h2 className="text-3xl font-black text-white uppercase mb-2" data-id="element-153">
            Qué incluye
          </h2>
          <p className="text-rosa font-bold" data-id="element-154">
            5 etapas que <strong data-id="element-155">cambian tu forma de relacionarte</strong>
          </p>
        </div>

        {/* Mobile carousel */}
        <div className="md:hidden" data-id="element-156">
          <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-4 hide-scrollbar" data-id="element-157">
            {modules.map((mod, idx) => <div key={idx} className="bg-dark rounded-xl overflow-hidden border border-white/10 flex flex-col flex-shrink-0 w-[80vw] max-w-[320px] snap-center" data-id="element-158">
                <div className="aspect-[9/16] w-full relative" data-id="element-159">
                  <ImageClickable src={mod.img} alt={`Módulo ${mod.num} - ${mod.title}`} className="w-full h-full object-cover rounded-none" data-id="element-160" />
                  <div className="absolute top-2 right-2 bg-terracota text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-161">
                    Módulo {mod.num}
                  </div>
                </div>
                <div className="p-3 text-center" data-id="element-162">
                  <h4 className="text-terracota font-semibold text-sm mb-1" data-id="element-163">
                    {mod.title}
                  </h4>
                  <p className="text-gray-400 text-xs" data-id="element-164">{mod.desc}</p>
                </div>
              </div>)}
          </div>
          {/* Instagram-style dot indicators */}
          <div className="flex justify-center gap-1.5 mt-3" data-id="element-165">
            {modules.map((_, idx) => <div key={idx} className={`rounded-full transition-all duration-300 ${idx === activeIndex ? 'w-2.5 h-2.5 bg-rosa' : 'w-2 h-2 bg-white/30'}`} data-id="element-166" />)}
          </div>
        </div>

        {/* Desktop grid */}
        <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-167">
          {modules.map((mod, idx) => <div key={idx} className="bg-dark rounded-xl overflow-hidden border border-white/10 flex flex-col group hover:border-rosa/50 transition-colors" data-id="element-168">
              <div className="aspect-[9/16] w-full relative" data-id="element-169">
                <ImageClickable src={mod.img} alt={`Módulo ${mod.num} - ${mod.title}`} className="w-full h-full object-cover rounded-none" data-id="element-170" />
                <div className="absolute top-2 right-2 bg-terracota text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-171">
                  Módulo {mod.num}
                </div>
              </div>
              <div className="p-3 text-center" data-id="element-172">
                <h4 className="text-terracota font-semibold text-sm mb-1" data-id="element-173">
                  {mod.title}
                </h4>
                <p className="text-gray-400 text-xs" data-id="element-174">{mod.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}